export const PastEventOptions = [
    { label:"Name", value: "name" },
    { label:"School", value: "brand" },
    { label:"Department", value: "department"},
    { label: "Activity", value: "activity"},
    { label: "Event Type", value:"event_type"},
    { label: "Date", value:"date" }
]